import { authedFetch } from '@features/auth/api/authRefresh'

/**
 * T-G7: Account profile REST client。
 *
 *   GET   /api/users/me        — プロファイル取得
 *   PATCH /api/users/me        — name 編集 (Phase 5 では name のみ)
 */

export interface MeProfileWire {
  id: string
  email: string
  name: string | null
  emailVerifiedAt: string | null
  createdAt: string
}

export const getMe = (): Promise<MeProfileWire> =>
  authedFetch<MeProfileWire>('/users/me', { method: 'GET' })

export const updateMe = (body: { name?: string }): Promise<MeProfileWire> =>
  authedFetch<MeProfileWire>('/users/me', { method: 'PATCH', body })
